import 'prismjs/themes/prism.css'
import './src/styles/tailwindcss.scss'
import './src/styles/global.scss'

const onServiceWorkerUpdateReady = () => console.log('Page updated!')

export { onServiceWorkerUpdateReady }
